import React from "react";
import Reveal from "./Reveal";

/**
 * Shared section header: a ruled line with an index label,
 * a condensed display word and an italic serif accent word.
 */
const SectionHeading = ({ id, index, label, title, accent, aside }) => (
    <header className="flex flex-wrap items-end justify-between gap-x-6 gap-y-4 border-t border-fg/15 pt-5">
        <div>
            <Reveal variant="fade">
                <p className="label text-fg">
                    <span className="text-accent-text">({index})</span>
                    <span className="ml-2">{label}</span>
                </p>
            </Reveal>
            <Reveal as="h2" id={id} variant="lines" className="mt-5 text-balance text-[clamp(2.4rem,4.4vw,3.75rem)] leading-[0.92]">
                <span className="mask-line">
                    <span className="display">{title}</span>
                </span>{" "}
                <span className="mask-line" style={{ "--line": 1 }}>
                    <span className="serif-accent text-accent-text">{accent}</span>
                </span>
            </Reveal>
        </div>
        {aside && (
            <Reveal variant="fade" delay={200}>
                {aside}
            </Reveal>
        )}
    </header>
);

export default SectionHeading;
